import styled from "styled-components";
import { TABLE_CELL_INPUT_MINIMUM_WIDTH } from "../../utilities/constants";
import { useLanguage } from "../LangTranslation/LanguageContext";
import TableLoader from "../Loaders/TableLoader";
import ProductVariantRow from "./ProductVariantRow";
import Modal from "../Kanban/Modal/Modal";
import { useState } from "react";
import ProductVariantDetails from "./ProductVariantDetails";
import { useSession } from "../../authentications/SessionContext";
import { getVariants } from "../../DataApi/products/getVarientsList";
import { getAttributeValues } from "../../DataApi/products/getAttributeValues";
import { primaryColor } from "../../utilities/colors";

const Button = styled.button`
  background-color: #fff;
  color: #ff5837;
  border: none;
  font-weight: 600;
  width: 130px;
  min-width: 150px;
  height: 40px;
  margin-right: 110px;
  outline: none; /* Remove default button outline */
`;
const VariantsBtn = styled.button`
  background-color: #fff;
  color: #ff5837;
  border: 1px solid #ff5837;
  border-radius: 10px;
  font-family: "Inter";
  font-weight: 600;
  transition: background-color 0.3s, color 0.3s;

  &:hover,
  &:focus,
  &:active {
    background-color: #ff5837;
    color: #fff;
  }
`;
function ProductVariants({
  push,
  handleRemove,
  name,
  form,
  disabled,
  selectedRecord,
}) {
  const { sessionInfo } = useSession();
  const { company_id, context, isVTEX } = sessionInfo;
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { values, setFieldValue } = form;
  const [variantsAttributesList, setVariantsAttributesList] = useState([]);
  const [productVariantDetail, setProductVariantDetail] = useState(false);
  const [productVariantList, setProductVariantList] = useState(false);
  const [isVariantModalOpen, setIsVariantModalOpen] = useState(false);
  const { attribute_line_ids } = values;
  // console.log(variantsAttributesList, "variantsAttributesList");
  const handleConfigureVariants = async (e) => {
    e.preventDefault();
    setIsVariantModalOpen(true);
    try {
      let response = await getVariants({
        context,
        company_id,
        id: selectedRecord.id,
      });
      response = JSON.parse(response);
      // console.log("varients list.......", response);
      let attrIds = [];
      response?.result?.records?.forEach((rec) => {
        attrIds = [...attrIds, ...rec.product_template_attribute_value_ids];
      });
      attrIds = new Set([...attrIds]);
      setVariantsAttributesList([...attrIds]);
      setProductVariantList(response?.result?.records);
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Modal
        isOpen={isVariantModalOpen}
        onClose={() => setIsVariantModalOpen(false)}
      >
        <ProductVariantDetails
          productVariantList={productVariantList}
          record_id={selectedRecord.id}
          variantsAttributesList={variantsAttributesList}
        />
      </Modal>
      <div className=" pb-4">
        {disabled && attribute_line_ids.length > 0 ? (
          <VariantsBtn
            className="my-3 btn btn-sm"
            onClick={(e) => handleConfigureVariants(e)}
            style={{
              background: isVTEX ? "#000000" : "#fff",
              color: isVTEX ? primaryColor.primary : "#ff5837",
              borderColor: isVTEX ? primaryColor.primary : "#ff5837",
            }}
          >
            <i className="bi bi-diagram-3-fill mx-2"></i>
            {t["Configure Variants"]}
          </VariantsBtn>
        ) : !disabled ? (
          ""
        ) : (
          <span
            className="alert alert-success d-flex align-items-center mb-0"
            role="alert"
            style={{
              height: 12 + "px",
              padding: "9px !important",
            }}
          >
            {t["In order to configure variants, add some!"]}{" "}
          </span>
        )}
        <div className="row overflow-auto">
          <table className="table position-relative">
            <thead>
              <tr className="heading_row">
                <th
                  style={{
                    textAlign: "center",
                    minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH,
                  }}
                >
                  {t["Variant"]}
                </th>

                <th
                  style={{
                    textAlign: "center",
                    minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH,
                  }}
                >
                  {t["Value"]}
                </th>
                {!disabled && <th style={{ minWidth: 20 }} />}
              </tr>
            </thead>

            <tbody style={{ minHeight: 120 }}>
              <TableLoader>
                {attribute_line_ids?.map((item, index) =>
                  item.isDeleted ? (
                    <></>
                  ) : (
                    <ProductVariantRow
                      key={index}
                      index={index}
                      item={item}
                      name={name}
                      handleRemove={handleRemove}
                      setFieldValue={setFieldValue}
                      disabled={disabled}
                      setProductVariantDetail={setProductVariantDetail}
                    />
                  )
                )}
              </TableLoader>
            </tbody>
          </table>
          {!disabled && (
            <Button
              onClick={() => {
                push({
                  id: `virtual_${parseInt(Math.random() * 1000)}`,
                  attribute_id: "",
                  value_ids: [],
                });
              }}
              role="button"
              type="button"
              style={{ color: isVTEX ? "#BAF76A" : "#ff5837" }}
            >
              + {t["Add Variant"]}
            </Button>
          )}
        </div>
      </div>
    </>
  );
}

export default ProductVariants;
